function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  opacity: 0.7,
  clipPath: "url(#playbutton_svg__clip0_301_63398)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z",
  fill: "#1FA956"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23 14.268c1.333.77 1.333 2.694 0 3.464l-9 5.196c-1.333.77-3-.192-3-1.732V10.804c0-1.54 1.667-2.502 3-1.732l9 5.196z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "playbutton_svg__clip0_301_63398"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v32H0z"
})));

function SvgPlaybutton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzMwMV82MzM5OCkiPgo8ZyBvcGFjaXR5PSIwLjciPgo8cGF0aCBkPSJNMTYgMzJDMjQuODM2NiAzMiAzMiAyNC44MzY2IDMyIDE2QzMyIDcuMTYzNDQgMjQuODM2NiAwIDE2IDBDNy4xNjM0NCAwIDAgNy4xNjM0NCAwIDE2QzAgMjQuODM2NiA3LjE2MzQ0IDMyIDE2IDMyWiIgZmlsbD0iIzFGQTk1NiIvPgo8cGF0aCBkPSJNMjMgMTQuMjY3OEMyNC4zMzMzIDE1LjAzNzYgMjQuMzMzMyAxNi45NjIyIDIzIDE3LjczMkwxNCAyMi45MjgxQzEyLjY2NjcgMjMuNjk3OSAxMSAyMi43MzU3IDExIDIxLjE5NjFWMTAuODAzN0MxMSA5LjI2NDE2IDEyLjY2NjcgOC4zMDE5MSAxNCA5LjA3MTcxTDIzIDE0LjI2NzhaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMzAxXzYzMzk4Ij4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgPlaybutton as ReactComponent };